import { useCallback, useEffect, useRef } from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { FORMAT_TIME } from 'constants/index';
import useChildren from 'hooks/useChildren';
import { getAgeFromMonthAndYear, getGenderText } from 'utils/helper';

const UsersDetailHeader = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { getDetailChild } = useChildren();

  const { me } = useSelector((state) => state.auth);
  const { childrenDetail } = useSelector((state) => state.children);
  const { currentLanguage } = useSelector((state) => state.language);

  const isCallingApi = useRef(false);

  const getChildren = useCallback(async () => {
    if (me && !isCallingApi.current) {
      isCallingApi.current = true;
      await getDetailChild(id);
    }
  }, [id, me]);

  useEffect(() => {
    getChildren();
  }, [getChildren]);

  return (
    <div className="w-full bg-teal-444/10 px-12 py-4 text-black/85 flex items-start gap-12" id="users-detail-header">
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('ID')}</div>
        <div>{childrenDetail?.id || '-'}</div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('FULL_NAME')}</div>
        <div className="font-bold text-2xl">{childrenDetail?.name || '-'}</div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('EMAIL_ADDRESS')}</div>
        <div>{childrenDetail?.user?.email || '-'}</div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('AGE')}</div>
        <div>
          {childrenDetail?.month && childrenDetail?.year
            ? getAgeFromMonthAndYear(childrenDetail?.month, childrenDetail?.year, t, currentLanguage)
            : '-'}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('GENDER')}</div>
        <div>{childrenDetail?.gender ? getGenderText(childrenDetail?.gender, t) : '-'}</div>
      </div>
       <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('BABY_NAME_THERAPIST')}</div>
        <div>
          {childrenDetail?.therapists?.length > 0
            ? childrenDetail.therapists.map((item, index) => (
              <p key={index}>{item?.name}</p>
            ))
            : '-'}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold text-xs">{t('REPORT_SENT_DATE_TIME')}</div>
        <div>{childrenDetail?.last_date_evaluation ? dayjs(childrenDetail?.last_date_evaluation).format(FORMAT_TIME.FULL_DATE_TIME) : '-'}</div>
      </div>
    </div>
  );
};

export default UsersDetailHeader;
